// extracted by mini-css-extract-plugin
module.exports = {"sorting-menu-container":"SortingMenu_sorting-menu-container__iSxJC","sorting-title-section":"SortingMenu_sorting-title-section__Y6RTG"};